<div class="modal-column">
  <div class="modal-container">
      <ng-container *ngIf="form.value">
        <form class="jackpot-transparency-grid try-it" (ngSubmit)="checkFairness()" [formGroup]="form" novalidate>
          <div class="transparency-check-item spaced">
            <h4>Input<br></h4>
            <div class="transparency-input">
              <div class="input-label">Casino seed</div>
              <app-form-input formControlName="serverSeed" class="width-full" [show-icons]=false
                              [no-validate]=true></app-form-input>
              <div class="_20-px-spacer"></div>
              <div class="input-label">Clients seed</div>
              <app-form-input formControlName="clientSeed" class="width-full" [show-icons]=false
                              [no-validate]=true></app-form-input>
              <div class="_20-px-spacer"></div>
              <app-form-button type="submit" class="primary width-100">Generate</app-form-button>
            </div>
          </div>
          <div class="transparency-check-item">
            <h4>Output<br></h4>
            <div class="transparency-input">
              <div class="input-label">Jackpot key code</div>
              <app-form-input formControlName="keyCode" class="width-full" [show-icons]=false [readonly]=true
                              [no-validate]=true></app-form-input>
              <div class="_20-px-spacer"></div>
              <div class="input-label">Participants name</div>
              <app-form-input formControlName="participantName" class="width-full" [show-icons]=false [readonly]=true
                              [no-validate]=true></app-form-input>
              <div class="_20-px-spacer"></div>
              <div class="text-block-3">
                Changing clients seed will change participant &amp; key code.
              </div>
            </div>
          </div>
        </form>
      </ng-container>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/jackpot-fairness/jackpot-fairness-modal.template.html